// eslint-disable-next-line max-classes-per-file
class CategoryPromotionDetail {
  key: string;

  name: string;

  constructor(data: any) {
    this.key = data.key || "";
    this.name = data.name || "";
  }
}

export class ResponseGetCategory {
  category: CategoryPromotionDetail[];

  total: number;

  constructor(data: any) {
    this.category = (data.category || []).map(
      (category: any) => new CategoryPromotionDetail(category),
    );

    this.total = data.total || 0;
  }
}
